import type { ReactNode } from 'react';

export interface TopBarProps {
  /** Page title — solid ink, never gradient. */
  title: string;
  /** Context/breadcrumb line rendered above the title (11px muted). */
  subtitle?: string;
  /** Page actions (secondary dropdowns, bell, primary brand button). */
  actions?: ReactNode;
  /** Dense 60px bar with a 17px title (crm). Default is the roomier elka bar (20px title). */
  dense?: boolean;
  className?: string;
}

/**
 * Calm-v2 top bar: surface bg, 1px line bottom border; title block on the
 * right (RTL), actions on the left.
 * Only valid in apps that import `@elka/theme` v2/calm.css.
 */
export function TopBar({ title, subtitle, actions, dense = false, className }: TopBarProps) {
  return (
    <div
      className={`bg-surface border-line flex items-center justify-between gap-4 border-b ${
        dense ? 'min-h-[60px] px-[22px] py-2' : 'px-6 py-4'
      } ${className ?? ''}`}
    >
      <div className="min-w-0">
        {subtitle && (
          <div className="text-muted mb-0.5 truncate text-[11px] font-semibold">{subtitle}</div>
        )}
        <h1
          className={`text-ink truncate font-extrabold tracking-[-0.3px] ${
            dense ? 'text-[17px]' : 'text-xl'
          }`}
        >
          {title}
        </h1>
      </div>
      <div className="flex shrink-0 items-center gap-2">{actions}</div>
    </div>
  );
}
